import React, { useState, useEffect } from "react"
import { IoCloseSharp } from "@react-icons/all-files/io5/IoCloseSharp"
import { IoMenuOutline } from "@react-icons/all-files/io5/IoMenuOutline"
import NavButtons from "./navButtons"

export default function Navigation() {
  // TODO: nav bar transition animations
  const [navVisible, setNavVisible] = useState("none")
  const navVisibility = () => {
  navVisible == "none" && setNavVisible("block")
  navVisible == "block" && setNavVisible("none")
  }

  return (
    <div>
      <div className="absolute z-10" style={{ right: 0, bottom: "10px" }}>
        <button
          onClick={navVisibility}
          className="p-3 rounded-full shadow-lg text-3xl text-shona m-2 -mt-3" 
          style={{ backgroundColor: "#FFEDC4" }}
        >
          {navVisible == "none" ? <IoMenuOutline /> : <IoCloseSharp />}
        </button>
      </div>

      <NavButtons
        bottom="210px"
        title="ShonaScript"
        display={navVisible}
        navigateTo="/"
      />
      <NavButtons
        bottom="140px"
        title="Dhaga"
        display={navVisible}
        navigateTo="/dhaga-code"
      />
      <NavButtons
        bottom="70px"
        title="Pictures"
        display={navVisible}
        navigateTo="/image"
      />
    </div>
  )
}
